module.exports = __webpack_public_path__ + "static/media/blade-runner.7f8c58eb.png";